/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Cloud Upload component.
 */
export const MaterialCloudUploadIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M40.063 16C29.1034 16 22.656 22.4474 18.7867 30.1842C10.4068 30.1842 1.50561 37.4053 2.0214 48.2369C2.53719 59.0684 13.199 64.1404 18.7867 65H64.563C68.8612 64.5702 77.4577 61.1316 77.4577 50.8158C77.4577 40.5 67.1419 36.2018 61.984 35.3421C61.984 26.3158 52.4419 16 40.063 16Z' stroke={iconColor} strokeWidth='3' />
      <path d='M34.2343 54.8299V45.5141C34.2343 45.2379 34.0105 45.0141 33.7343 45.0141H26.4151C25.9697 45.0141 25.7466 44.4755 26.0616 44.1605L38.3939 31.8282C38.5892 31.6329 38.9058 31.6329 39.101 31.8282L51.4334 44.1605C51.7484 44.4755 51.5253 45.0141 51.0799 45.0141H43.7606C43.4845 45.0141 43.2606 45.2379 43.2606 45.5141V54.8299C43.2606 55.106 43.0368 55.3299 42.7606 55.3299H34.7343C34.4582 55.3299 34.2343 55.106 34.2343 54.8299Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialCloudUploadIcon;
